<template>

    <FlashNotifications ref="flash" />
        
    <div class="md:px-12 lg:px-20 xl:px-32 xl:max-w-[85rem] mx-auto">
        <EventsList></EventsList>
    </div>
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import FlashNotifications from "controllers/vue_components/flash_toast"
import EventsList from "controllers/vue_components/shared/events/list"

export default {
    name: 'OrganizationEvents',
    props: [],
    mixins: [Constants, RequestMixin],
    components: {
        FlashNotifications,
        EventsList
    },
    data() {
        return {

        };
    },
    methods: { },
    computed: { },
    watch: { },
    created() { }
};
</script>
